import React from 'react';

export interface SignMin8IconProps {}

export const SignMin8Icon: React.FC<SignMin8IconProps> = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13 2.75C16.5899 2.75 19.5 5.66015 19.5 9.25V21H16.5V9.25C16.5 7.317 14.933 5.75 13 5.75C11.067 5.75 9.5 7.317 9.5 9.25V15.3655L13.2815 14.0287C13.5418 13.9367 13.8275 14.0731 13.9195 14.3335C13.9791 14.5021 13.9441 14.6897 13.8278 14.8255L7.97406 21.6552L2.12037 14.8255C1.94067 14.6159 1.96496 14.3002 2.17462 14.1205C2.31042 14.0041 2.49805 13.9691 2.66668 14.0287L6.5 15.384V9.25C6.5 5.66015 9.41015 2.75 13 2.75Z"
        fill="#192033"
      />
    </svg>
  );
};
